import { useEffect, useState } from 'react';
import { apiFetch, getMe, type TokenResponse } from '@/lib/api';
import { useAuthStore } from '@/stores/authStore';

let bootstrapPromise: Promise<void> | null = null;

function runBootstrap(): Promise<void> {
  bootstrapPromise ??= (async () => {
    const rt = useAuthStore.getState().refreshToken;
    if (!rt) return;
    try {
      const tokens = await apiFetch<TokenResponse>(
        '/auth/refresh',
        { method: 'POST', body: JSON.stringify({ refreshToken: rt }) },
        false,
      );
      useAuthStore.getState().setTokens(tokens);
      useAuthStore.getState().setUser(await getMe());
    } catch {
      useAuthStore.getState().clear();
    }
  })();
  return bootstrapPromise;
}

/**
 * Restaura sessão a partir do refresh token persistido. Não bloqueia
 * a UI pública — consumidores que precisam aguardar (ex.: AppLayout)
 * leem o `ready`.
 */
export function useSessionBootstrap() {
  const initiallyReady = !useAuthStore.getState().refreshToken;
  const [ready, setReady] = useState(initiallyReady);

  useEffect(() => {
    let cancelled = false;
    runBootstrap().finally(() => {
      if (!cancelled) setReady(true);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return ready;
}
